module.exports = __webpack_public_path__ + "static/media/kobblest._holland.24d562d7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/personal/normals/kobblest._holland.jpg
// module id = 415
// module chunks = 0